import React from "react";
import CountWidget from "../Widgets/CountWidget";
import RateWidget from "../Widgets/RateWidget";
import CallOutcomesWidget from "../Widgets/CallOutcomesWidget";
import LinkedInOverviewWidget from "../Widgets/LinkedInOverviewWidget";
import CallsByMemberWidget from "../Widgets/CallsByMemberWidget";
import { RATE_WIDGET_IDS } from "../utils/widgetConstants";

const DUMMY_TREND = { percent: 12, direction: "up" };
const DUMMY_TREND_DOWN = { percent: 8, direction: "down" };

const DUMMY_RATE_CHART = [
  { label: "Mon", value: 28 },
  { label: "Tue", value: 34 },
  { label: "Wed", value: 22 },
  { label: "Thu", value: 41 },
  { label: "Fri", value: 36 },
  { label: "Sat", value: 19 },
  { label: "Sun", value: 30 }
];

const DUMMY_CALL_OUTCOMES = [
  { outcome: "Connected",  count: 28 },
  { outcome: "No Answer",  count: 47 },
  { outcome: "Voicemail",  count: 15 },
  { outcome: "Not Logged", count: 9  }
];

const DUMMY_LINKEDIN_DATA = {
  connectionsSent:     50,
  connectionsAccepted: 20,
  messagesSent:        30,
  messagesReplied:     8,
  profileViewed:       60
};

const DUMMY_CALLS_BY_MEMBER = [
  { name: "Alice",  Connected: 18 },
  { name: "Bob",    Connected: 12 },
  { name: "Carol",  Connected: 25 },
  { name: "David",  Connected: 9  }
];

const DUMMY_DATA_BY_WIDGET = {
  EMAILS_SENT:              { value: 1284, trend: DUMMY_TREND },
  BOUNCES:                  { value: 24,   trend: DUMMY_TREND_DOWN },
  MANUAL_EMAILS_SENT:       { value: 142,  trend: DUMMY_TREND },
  SEQUENCE_EMAILS_SENT:     { value: 1142, trend: DUMMY_TREND },
  CALLS_CONNECTED:          { value: 86,   trend: DUMMY_TREND },
  TOTAL_CALLING_MINUTES:    { value: 312,  trend: DUMMY_TREND },
  CONNECTIONS_SENT:         { value: 50,   trend: DUMMY_TREND },
  CONNECTIONS_ACCEPTED:     { value: 20,   trend: DUMMY_TREND },
  TASKS_COMPLETED:          { value: 45,   trend: null },
  SEQUENCE_TASKS_COMPLETED: { value: 30,   trend: null },
  MEETINGS_BOOKED:          { value: 7,    trend: DUMMY_TREND }
};

const DUMMY_RATE_BY_WIDGET = {
  EMAIL_OPEN_RATE:    { currentRate: 40.3, trend: DUMMY_TREND,      chartData: DUMMY_RATE_CHART },
  EMAIL_REPLY_RATE:   { currentRate: 12.7, trend: DUMMY_TREND,      chartData: DUMMY_RATE_CHART },
  CONNECT_RATE:       { currentRate: 18.5, trend: DUMMY_TREND_DOWN, chartData: DUMMY_RATE_CHART },
  LINKEDIN_REPLY_RATE:{ currentRate: 22.1, trend: DUMMY_TREND,      chartData: DUMMY_RATE_CHART }
};

const WidgetPreview = ({ widgetId }) => {
  if (!widgetId) return null;

  if (RATE_WIDGET_IDS.has(widgetId)) {
    const d = DUMMY_RATE_BY_WIDGET[widgetId] || {};
    return (
      <RateWidget
        currentRate={d.currentRate}
        trend={d.trend}
        chartData={d.chartData}
        dateFilter="7d"
      />
    );
  }

  if (widgetId === "CALL_OUTCOMES") {
    return <CallOutcomesWidget callOutcomes={DUMMY_CALL_OUTCOMES} />;
  }

  if (widgetId === "LINKEDIN_OVERVIEW") {
    return <LinkedInOverviewWidget data={DUMMY_LINKEDIN_DATA} />;
  }

  if (widgetId === "CALLS_BY_MEMBER") {
    return <CallsByMemberWidget callsByMember={DUMMY_CALLS_BY_MEMBER} />;
  }

  const d = DUMMY_DATA_BY_WIDGET[widgetId] || { value: 0, trend: null };
  return <CountWidget value={d.value} trend={d.trend} />;
};

export default WidgetPreview;
